<template>
    <div class="unitSearch">
        <div class="content myflex-lv">
            <div class="text-center">
                <div class="font1 mb5">共享行动单位查询</div>
                <div class="font2 mb20">全民终身学习教育资源共享行动</div>
                <div class="myflex searchBtnBox">
                    <div class="flex1">
                        <input type="text" class="searchInput" v-model.trim="no" placeholder="请输入要查询的共享行动单位名称或序号">
                    </div>
                    <span class="searchBtn" @click="search">查询</span>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
export default {
    name: "unitSearch",
    components: {
    },
    data(){
        return {
            no:'',
        }
    },
    methods:{
        //查询
        search(id){
            const vm = this;
            if(!vm.no) return;
            const newurl = this.$router.resolve({name: 'instStudioList', query: {
                activeName: 'second',
                searchText2: encodeURIComponent(vm.no),
            }})
            window.open(newurl.href,'_blank');
            return;
            let params = {
                no: vm.no
            }
            vm.$api.pub.getStudioIdByStudioAllianceNo(params).then(res => {
                var studioId = res.body.studioId;
                const newurl = this.$router.resolve({name: 'studioDetail', query: {id: studioId}})
                window.open(newurl.href,'_blank');
                vm.no = '';
            }).catch(res => {
               
            })
        },
    },
    created: function(){
    }
};
</script>   

<style lang="scss" scoped>
    .unitSearch{width:100%;height:159px;}
    .content{@include bg-img('../../assets/img/unitSearchBg.jpg');height:100%;}
    .font1{font-size:18px;font-weight:600;color:#fff;}
    .font2{color:#aeb4b9;font-size:16px;}
    .searchInput{-webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);width:450px;font-size:16px;}
    .searchInput::-webkit-input-placeholder { color: #a7a7a7; } 
    .searchBtn{@include bg-themecolor(1);width:106px;color:#fff;line-height:40px;text-align:center;cursor:pointer;font-size:16px;}
    .searchBtn:hover{@include bg-themecolor(.9);}
    @media screen and(max-width:700px){
        .searchBtnBox{width:80vw;}
        .searchInput{width:100%;font-size:14px;}
    }
</style>
